import { Col, Row, Button, Form, Input, Checkbox } from 'antd';
import React, { useState } from 'react';
import style from './CardChangePassword.module.scss'
import { SizeType } from 'antd/es/config-provider/SizeContext';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { validatePassword } from '../../../globals/Inputs/validateInput';
import { AppState } from '../../../store';
import { connect } from 'react-redux';
import { putUpdatePassword,putUpdateAdminPassword } from '../../../store/user/thunks';
import { UserState } from '../../../store/user/types';
import ErrorMessage from '../../../globals/Components/Error/ErrorMessage';
import { postAccountLoginUser } from '../../../store/user/thunks';

type RequiredMark = boolean | 'optional';

interface ChangePasswordProps {
    putUpdatePassword?: any;
    user?: UserState;
    terms: boolean;
    errorMessage?: any;
    id:string;
    putUpdateAdminPassword?:any;
    typeCard: String;

}
const CardChangePassword: React.FC<ChangePasswordProps> = (props: ChangePasswordProps) => {
    const messageResponse = (
        <ErrorMessage>
            {props.errorMessage?.message.map((item: string | null | undefined) => {
                return <p>{item}</p>
            })}
        </ErrorMessage>
    );
    const [form] = Form.useForm();
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const onFinish = async (values: any) => {   
        
         let idPassword;
        if(props.id == ""){
            idPassword = props.user?.id;
            const registerUser = {
                id: idPassword, // idPassword,
                password: values.confirmpassword,
            };
            const responseData = await props.putUpdateAdminPassword(registerUser);
        }else{
            idPassword = props.id;
            const registerUser = {
                id: idPassword,
                password: values.confirmpassword,
            };
            const responseData = await props.putUpdatePassword(registerUser);
            if(responseData != undefined){
                window.location.replace(process.env.REACT_APP_BASE_URL as string);
            }
            
        }
             
        form.resetFields();
      
        
        

    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };
    return (
        <div className={style["container"]}>
            <div className={style["card"+props.typeCard]}>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}>
                    <Form.Item className={style["justifyForm"]} name="password" rules={[
                        { required: true, message: validateMessages.emptyField }
                    ]}>
                        <Input.Password placeholder="Ingresar nueva contraseña" />
                    </Form.Item>
                    <div className={style["password-details"]}>
                        La contraseña debe tener de 8 a 14 caracteres, al menos una mayúscula y un número.
                    </div>
                    <Form.Item className={style["justifyForm"]} name="confirmpassword" rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                let message = "";
                                message = validatePassword(value, getFieldValue('password'))
                                if (message != "") {
                                    return Promise.reject(new Error(message));
                                } else {
                                    return Promise.resolve();
                                }
                            },
                        }),
                        { required: true, message: validateMessages.emptyField }
                    ]}>
                        <Input.Password placeholder="Ingresar nuevamente la contraseña" />
                    </Form.Item>                 

                    {messageResponse}

                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            Ingresar nueva contraseña
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};


const mapStateToProps = (state: AppState) => ({
    user: state.user,
    errorMessage: state.system.messageResponse
});

export default connect(mapStateToProps, {
    putUpdatePassword,putUpdateAdminPassword
})(CardChangePassword);